import React from 'react'
import styled from 'styled-components'
import Responsive from '../../assets/config/Responsive'
import Colors from '../../assets/styles/Colors'
import { Container } from '../../assets/styles/GlobalStyle'
import Logo from '../../assets/icons/JSX/Logo'
import LogoGe from '../../assets/icons/JSX/LogoGe'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../store'
import { AppState } from '../../store/appSlice'
//
//
const ScreenHeader: React.FC<{
  totalCount?: number
  passedCount?: number
  onClick?: () => void
  rightSideChildren?: React.ReactNode
}> = ({ totalCount, passedCount, onClick, rightSideChildren }) => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const navigate = useNavigate()
  //
  return (
    <Wrapper>
      <Container>
        <HeaderRow>
          {lang === 'ge' ? (
            <LogoGeStyle onClick={() => navigate('/')} />
          ) : lang === 'en' ? (
            <LogoEnStyle onClick={() => navigate('/')} />
          ) : (
            <LogoEnStyle onClick={() => navigate('/')} />
          )}
          <Counts>
            {rightSideChildren}
            {passedCount && (
              <Passed>
                {passedCount <= 9 ? 0 : null}
                {passedCount}
              </Passed>
            )}
            {totalCount && (
              <Total>
                <span>/</span>
                {totalCount <= 9 ? 0 : null}
                {totalCount}
              </Total>
            )}
          </Counts>
        </HeaderRow>
      </Container>
    </Wrapper>
  )
}
//
// styles
const LogoGeStyle = styled(LogoGe)`
  width: 90px;
  height: 40px;
  cursor: pointer;
  user-select: none;

  ${Responsive.mobile} {
    width: 64px;
    height: 28px;
  }
`
const LogoEnStyle = styled(Logo)`
  width: 90px;
  height: 40px;
  cursor: pointer;
  user-select: none;

  ${Responsive.mobile} {
    width: 64px;
    height: 28px;
  }
`
const Passed = styled.span`
  font-size: 18px;
  color: ${Colors.primaryBlack};
`
const Total = styled.span`
  font-size: 14px;
  color: ${Colors.nevadaGrey};

  span {
    margin-inline: 5px;
    font-size: 16px;
  }
`
const Counts = styled.div``

const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const Wrapper = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 88px;
  background-color: ${Colors.white};
  display: flex;
  align-items: center;
  user-select: none;
  z-index: 5;
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;
  padding-left: 100px;
  padding-right: 100px;

  ${Responsive.mobile} {
    padding-left: 0px;
    padding-right: 0px;
    height: 64px;
  }
`

export default ScreenHeader
